export const environment = {
    enableBugsnag: false,
    production: false,
    apiUrl: 'https://staging.cat-risk.com/api',
    gmap_key: 'AIzaSyDhnCkyEXNaRnHmm90R-pUGlAWtK7WnIZo',
    baseUrl: 'https://staging.cat-risk.com',
    captcha_siteKey: '6LfZW_srAAAAACWG6dJsgos-954mPZokNfJu_aX9',
    frontendUrl: 'https://staging-app.yokahu.co',
    chatbotApiUrl: 'https://staging.cat-risk.com/chat-api'
  }
